import React from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@material-ui/core";

import { RenderDefaultServiceSlots } from "../CompleteSetup/SlotsInformation/DefaultServiceSlot";
import {
  capitalizeFirstLetter,
  isObjectEmptyOrNull,
  isUndefined,
} from "../../utils/DataUtils";
import { ExpandMoreAccordianIcon } from "../common/App/AppViewUtils";
import { APPLICATION_TEXT_CONSTANT, SERVICE_TYPES } from "config/constants";

interface RenderDefaultSupplierAllInformationInterface {
  classes: any;
  supplierTypes: any;
  serviceTypeName?: string;
  holidayConfig?: { weeklyOffDays: string[] };
}

const RenderDefaultSupplierAllInformation = (
  props: RenderDefaultSupplierAllInformationInterface,
) => {
  const { classes, supplierTypes, serviceTypeName, holidayConfig } = props;
  const weeklyHolidayEnabled = (holidayConfig?.weeklyOffDays?.length ?? 0) > 0;

  const isSupplierTypeDataPresent = () => {
    return !isUndefined(supplierTypes) && !isObjectEmptyOrNull(supplierTypes);
  };

  if (serviceTypeName?.toUpperCase() === SERVICE_TYPES.DEFAULT) {
    return (
      <>
        {isSupplierTypeDataPresent() ? (
          Object.keys(supplierTypes).map((supplier, supplierIndex) => (
            <Accordion
              key={supplierIndex}
              className={classes.accordion}
              onClick={(e) => e.stopPropagation()}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreAccordianIcon />}
                className={`${classes.accordionSummary} ${classes.collectionPointAccSummary}`}
                onClick={(e: any) => e.stopPropagation()}
              >
                <Grid container alignItems="center">
                  <Grid item xs={10}>
                    {`${capitalizeFirstLetter(supplier)}`}
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails className={classes.collectionPointAccDetails}>
                <Grid container>
                  <Grid item className={classes.slotsAllDaysText}>
                    Slots (All Days)
                  </Grid>
                  <Grid item xs={12} className={classes.dayWiseSlotsContainer}>
                    <RenderDefaultServiceSlots
                      dayWiseSlots={supplierTypes[supplier].dayWiseSlots}
                      classes={classes}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          ))
        ) : (
          <></>
        )}
      </>
    );
  }

  return (
    <>
      <Grid container className={classes.detailsSection}>
        <Grid item className={classes.slotsAllDaysText}>
          {APPLICATION_TEXT_CONSTANT.ADDITIONAL_ZONE_CONFIGURATION}
        </Grid>
        <Grid item xs={12} className={classes.weeklyHolidaysSection}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <Typography component="span" className={classes.fieldTitleStyle}>
                {APPLICATION_TEXT_CONSTANT.WEEKLY_HOLIDAYS}:
              </Typography>
            </Grid>
            <Grid item>
              <Typography component="span" className={classes.fieldData}>
                {weeklyHolidayEnabled ? "Enabled" : "Disabled"}
              </Typography>
            </Grid>
          </Grid>
          {weeklyHolidayEnabled && (
            <Typography className={classes.fieldData}>
              {holidayConfig?.weeklyOffDays?.join(", ")}
            </Typography>
          )}
        </Grid>
      </Grid>
      {isSupplierTypeDataPresent() ? (
        Object.keys(supplierTypes).map((supplier, supplierIndex) => (
          <Accordion
            key={supplierIndex}
            className={classes.accordion}
            onClick={(e) => e.stopPropagation()}
          >
            <AccordionDetails className={classes.collectionPointAccDetails}>
              <Grid container>
                <Grid item className={classes.slotsAllDaysText}>
                  Slots (All Days)
                </Grid>
                <Grid item xs={12} className={classes.dayWiseSlotsContainer}>
                  <RenderDefaultServiceSlots
                    dayWiseSlots={supplierTypes[supplier].dayWiseSlots}
                    classes={classes}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        ))
      ) : (
        <></>
      )}
    </>
  );
};

export default React.memo(RenderDefaultSupplierAllInformation);
